import script from "./SinResultados.vue?vue&type=script&setup=true&lang=js"
export * from "./SinResultados.vue?vue&type=script&setup=true&lang=js"

import "./SinResultados.vue?vue&type=style&index=0&id=0e7f2bf9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e7f2bf9"]])

export default __exports__